<div class="bg-white rounded-lg h-full w-full border flex flex-col">
  <!-- Header -->
  <div class="p-5 py-3 flex items-center justify-between border-b capitalize">
    <p class="text-sm font-semibold">Platform Usage</p>
    <select *ngIf="filter" class="select select-ghost select-xs">
      <option value="video-content">Video Content</option>
      <option value="flashcard">Flashcards</option>
      <option value="all-tests">All Tests</option>
    </select>
  </div>

  <div class="p-5">
    <!-- Chart -->
    <app-bar-chart [height]="260" [chartlabel]="false"></app-bar-chart>
  </div>


</div>
